import script from "./ImportsForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ImportsForm.vue?vue&type=script&setup=true&lang=js"

import "./ImportsForm.vue?vue&type=style&index=0&id=352bbd34&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/campus-heating-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-352bbd34"]])

export default __exports__